import _ from 'lodash';
import moment from 'moment';
import { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { Button } from 'react-bootstrap';
import LoadingPage from '../LoadingPage';
import MaterialSearch from '../MaterialSearch';
import Api from '../../services/ApiService';
import Form from '../form/Form';

import '../../styles/archive.scss';

class UnsignedDocs extends Component {
  constructor(props) {
    super(props);
    const now = moment().format('YYYY-MM-DD');
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');

    this.state = {
      results: [],
      searchText: 'name:(*)',
      startDate: yesterday,
      endDate: now,
      unsigned: true,
      quickFilterText: '',
      count: 0,
      ready: false,
      loading: true,
      dataRefreshing: false,
    };

    this.layout = [
      {
        name: 'startDate',
        col: 2,
        label: 'Start Date',
        type: 'date',
        data: this.state.startDate,
      },
      {
        name: 'endDate',
        col: 2,
        label: 'End Date',
        type: 'date',
        data: this.state.endDate,
      },
      {
        name: 'unsigned',
        label: 'Doc UnSigned',
        options: [
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
          { value: 0, label: 'Both' },
        ],
        type: 'string',
        col: 1,
        noEmptyOption: true,
      },
      {
        name: 'searchText',
        label: 'Document Search',
        type: 'string',
        col: 6,
      },
    ];

    this.debouncedGetSearchResults = _.debounce(this.getSearchResults, 250);
    this.handleQuickFilter = this.handleQuickFilter.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
    this.updateFormData = this.updateFormData.bind(this);
    this.getSearchResults = this.getSearchResults.bind(this);
    this.onDisplayDocument = this.onDisplayDocument.bind(this);
  }

  componentDidMount() {
    this.debouncedGetSearchResults(this.state.searchText, this.state);
  }

  onGridReady() {
    // Oddly, this is called twice.  The component isn't mounted until this.agGrid ref is set.
    if (this.agGrid && this.agGrid.api.getModel().rowsToDisplay) {
      this.setState({ count: this.agGrid.api.getModel().rowsToDisplay.length });
      this.agGrid.columnApi.autoSizeAllColumns();
    }
  }

  onFilterChanged() {
    if (!this.agGrid) {
      return;
    }

    this.setState({ count: this.agGrid.api.getModel().rowsToDisplay.length });
  }

  onDisplayDocument() {
    // console.log('here');
    // console.log(this.state);
    // window.open(FileService.downloadPath(this.state.filename));
  }

  getSearchResults(query, unsigned = true) {
    Api.get('archive/search', {
      params: {
        q: window.btoa(query),
        limit: 500,
        page: this.page,
        from: 'UCS2',
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        unsigned: this.state.unsigned || unsigned,
      },
    }).then(response => {
      if (this.state.searchText === query) {
        // don't update the state if the query has since changed
        const results = this.page > 1 ? [].concat(this.state.results, response.data) : response.data;
        this.setState({
          results,
          ready: true,
          count: results.length || 0,
          loading: false,
          dataRefreshing: false,
        });
      }
    });
  }

  getColumnDefs() {
    return [
      {
        headerName: 'Name',
        cellStyle: { textAlign: 'center' },
        field: 'name',
        width: 300,
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerName: 'Date',
        field: 'date',
        sort: 'desc',
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerName: 'Type',
        field: 'type',
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerName: 'Signed Copy',
        field: 'signed',
        width: 100,
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerName: 'Path',
        cellStyle: { textAlign: 'left' },
        field: 'filePath',
        width: 900,
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        cellRenderer: 'myCellRenderer',
      },
    ];
  }

  myCellRenderer() {
    // console.log('Clicked');
  }

  updateFilter() {
    this.setState({
      dataRefreshing: true,
    });
    this.getSearchResults(this.state.searchText, this.state);
  }

  updateFormData({ form }) {
    const filterData = [];

    _.each(form, value => {
      filterData[value.name] = value.data;
    });

    this.setState({
      startDate: moment(filterData.startDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
      endDate: moment(filterData.endDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
      unsigned: filterData.unsigned,
      searchText: `name(${filterData.searchText}*)`,
    });
  }

  handleQuickFilter(e) {
    this.setState({ quickFilterText: e.target.value });
  }

  render() {
    const columnDefs = this.getColumnDefs();
    let refreshing = '';
    const divStyle = {
      color: 'red',
      textAlign: 'center',
      fontSize: 15,
      width: '100%',
      height: 30,
    };

    if (!this.state.ready) {
      return <LoadingPage />;
    }

    if (this.state.dataRefreshing) {
      // refreshing = <div className="dataRefresh" style={divStyle}>Refreshing Data...</div>;
      refreshing = <h5 style={divStyle}>Data Refreshing...</h5>;
    }

    return (
      <div id="list-container" className="content-container" style={{ display: 'block' }}>
        <div id="filter" style={{ display: 'flex', height: '10%', width: '100%' }}>
          <Form layout={this.layout} onChange={this.updateFormData} hideSubmit hideCancel />
          <div style={{ display: 'flex', height: '40px', width: '20%' }}>
            <Button
              id="filter-button"
              title="Apply Filter"
              onClick={() => {
                this.updateFilter();
              }}
            >
              <i className="zmdi zmdi-plus zmdi-hc-lg" />
              &nbsp;Apply Filter
            </Button>
          </div>
        </div>
        {refreshing}
        <MaterialSearch
          onChange={this.handleQuickFilter}
          placeholder="Quick Filter Results"
          results={this.state.count}
          value={this.state.quickFilterText}
        />
        <div
          id="grid-wrapper"
          ref={el => {
            this.agGridContainer = el;
          }}
          className="ag-theme-balham"
        >
          <div style={{ width: '100%' }}>
            <AgGridReact
              ref={el => {
                this.agGrid = el;
              }}
              quickFilterText={this.state.quickFilterText}
              onGridReady={this.onGridReady}
              columnDefs={columnDefs}
              rowData={this.state.results}
              modules={AllModules}
              suppressCellFocus
              rowHeight="32"
              enableSorting
              enableFilter
              enableColResize
              suppressExcelExport
            />
          </div>
        </div>
      </div>
    );
  }
}

export default UnsignedDocs;
